import { render, staticRenderFns } from "./TabGerarCobranca.vue?vue&type=template&id=8f254554&"
import script from "./TabGerarCobranca.vue?vue&type=script&lang=js&"
export * from "./TabGerarCobranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports